import ReleaseDetectionSettings from './ReleaseDetectionSettings';
import { SettingValues } from '@linearb/linjs-common';
import { validateHasChangedWithValue } from '../../SettingsUtils';
import AppRouter from 'common/AppRouter';

const customOptions = {
  lighthouse: {
    code: 'vnw2fw6226',
    description: 'Learn more >'
  },
  confirmation_modal: {
    checkbox: {
      key: 'backfill_days_backward',
      label: 'Please backfill my releases for the last 90 days',
      checked_value: 90,
      unchecked_value: 1,
      is_checked_by_default: true
    },
    confirmation_text:
      'This change may affect your historical data including deployment frequency, cycle time and more. It might take the changes a couple of hours to take affect, depending on the size of your environment'
  }
};

const getSubtext = definitionLevel => {
  return definitionLevel === 'repository'
    ? 'Select the way you would like LinearB will detect releases.'
    : `Select the way you would like LinearB will detect releases.<br><strong>Note:</strong> This change will affect how LinearB detects your releases across all repositories.<br>To change the way releases are detected  for specific repositories only, <a href="${AppRouter.REPOSITORIES.path}" style="text-decoration:none">click here ></a>`;
};

const ReleaseDetectionSettingsFFOff = props => {
  const { definitionLevel } = props;
  return (
    <ReleaseDetectionSettings
      key={SettingValues.RELEASES_STRATEGY}
      name={SettingValues.RELEASES_STRATEGY}
      namespace='releases'
      customOptions={customOptions}
      useEffectValidationFN={validateHasChangedWithValue}
      label={'Releases detection'}
      defaultValue={{
        key: 'tag',
        regex_pattern: '.*',
        backfill_days_backward: 90
      }}
      subtext={getSubtext(definitionLevel)}
      {...props}
    />
  );
};

export default ReleaseDetectionSettingsFFOff;
